import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { ThirdPartyPayroll } from './third-party-payroll.model';
import { PayrollCode } from './payroll-code.model';
import { FileFormatModel } from './file-format.model';
import { ReimbursementPaycode } from './reimbursement-paycode.model';
import { Observable } from 'rxjs';
import { SyncGeneralLedgerResponseModel } from './sync-general-ledger-response.model';

export const loadThirdPartyPayrolls = createAction(
    '[ThirdPartyPayroll/API] Load ThirdPartyPayrolls',
    props<{ thirdPartyPayrolls: ThirdPartyPayroll[] }>()
);

export const addThirdPartyPayroll = createAction(
    '[ThirdPartyPayroll/API] Add ThirdPartyPayroll',
    props<{ thirdPartyPayroll: ThirdPartyPayroll }>()
);

export const upsertThirdPartyPayroll = createAction(
    '[ThirdPartyPayroll/API] Upsert ThirdPartyPayroll',
    props<{ thirdPartyPayroll: ThirdPartyPayroll }>()
);

export const addThirdPartyPayrolls = createAction(
    '[ThirdPartyPayroll/API] Add ThirdPartyPayrolls',
    props<{ thirdPartyPayrolls: ThirdPartyPayroll[] }>()
);

export const upsertThirdPartyPayrolls = createAction(
    '[ThirdPartyPayroll/API] Upsert ThirdPartyPayrolls',
    props<{ thirdPartyPayrolls: ThirdPartyPayroll[] }>()
);

export const updateThirdPartyPayroll = createAction(
    '[ThirdPartyPayroll/API] Update ThirdPartyPayroll',
    props<{ thirdPartyPayroll: Update<ThirdPartyPayroll> }>()
);

export const updateThirdPartyPayrolls = createAction(
    '[ThirdPartyPayroll/API] Update ThirdPartyPayrolls',
    props<{ thirdPartyPayrolls: Update<ThirdPartyPayroll>[] }>()
);

export const deleteThirdPartyPayroll = createAction(
    '[ThirdPartyPayroll/API] Delete ThirdPartyPayroll',
    props<{ id: string }>()
);

export const deleteThirdPartyPayrolls = createAction(
    '[ThirdPartyPayroll/API] Delete ThirdPartyPayrolls',
    props<{ ids: string[] }>()
);

export const clearThirdPartyPayrolls = createAction(
    '[ThirdPartyPayroll/API] Clear ThirdPartyPayrolls'
);
export const getThirdPartyPayrolls = createAction(
    '[ThirdPartyPayroll/API] Get ThirdPartyPayrolls'
);
export const getReimbursementPaycodes = createAction(
    '[ThirdPartyPayroll/API] Get ReimbursementPaycodes'
);
export const getPayrollCodes = createAction(
    '[ThirdPartyPayroll/API] Get PayrollCodes'
);
export const loadPayrollCodes = createAction(
    '[ThirdPartyPayroll/API] Load PayrollCodes',
    props<{ payrollCodes: PayrollCode[] }>()
);
export const loadReimbursementPaycodes = createAction(
    '[ThirdPartyPayroll/API] Load ReimbursementPaycodes',
    props<{ reimbursementPaycodes: ReimbursementPaycode[] }>()
);
export const putPayrollCodes = createAction(
    '[ThirdPartyPayroll/API] Load putPayrollCodes',
    props<{ payrollCodes: PayrollCode[] }>()
);
export const getFileFormat = createAction(
    '[ThirdPartyPayroll/API] getFileFormat'
);
export const loadFileFormat = createAction(
    '[ThirdPartyPayroll/API] loadFileFormat',
    props<{ fileFormats: FileFormatModel[] }>()
);
export const putFileFormat = createAction(
    '[ThirdPartyPayroll/API] putFileFormat',
    props<{ fileFormats: FileFormatModel[] }>()
);
export const removePayrollCode = createAction(
    '[ThirdPartyPayroll/API] removePayrollCode',
    props<{ payrollId: number }>()
);
export const deletePayrollCodes = createAction(
    '[ThirdPartyPayroll/API] deletePayrollCodes',
    props<{ payrollIds: number[] }>()
);
export const confirmRemovePayrollCode = createAction(
    '[ThirdPartyPayroll/API] confirmRemovePayrollCode',
    props<{ payrollCode: PayrollCode }>()
);
export const getPayrollExport = createAction(
    '[ThirdPartyPayroll/API] getPayrollExport',
    props<{ startDate: Date; endDate: Date; codeAsRow: boolean }>()
);
export const sendPayrollExport = createAction(
    '[ThirdPartyPayroll/API] sendPayrollExport',
    props<{ id: string | number | undefined; endDate: Date }>()
);
export const sendPayrollExportSuccess = createAction(
    '[ThirdPartyPayroll/API] sendPayrollExportSuccess',
    props<{ result: any }>()
);
export const syncGL = createAction(
    '[ThirdPartyPayroll/API] syncGL',
    props<{ id: string | number | undefined; endDate: Date }>()
);
export const syncGLSuccess = createAction(
    '[ThirdPartyPayroll/API] syncGLSuccess',
    props<{ result?: SyncGeneralLedgerResponseModel }>()
);
export const syncGLFailure = createAction(
    '[ThirdPartyPayroll/API] syncGLFailure',
    props<{ e: any; c: Observable<any>; id: string | number | undefined }>()
);
export const fetchPayrollExportStatus = createAction(
    '[ThirdPartyPayroll/API] fetchPayrollExportStatus',
    props<{ id: string | number }>()
);
